export const AWS_REGION = 'eu-central-1';
export const AWS_USER_POOL_ID = 'eu-central-1_OKvTSIjih';
export const AWS_USER_POOL_WEB_CLIENT_ID = '2o9foqne50cp3agdr0oahg1hsl';
export const AWS_IDENTITY_POOL_ID = 'eu-central-1:f8ca49e0-dc04-4152-8881-0fc1d1c44e12';
export const BASE_URL = 'https://api.ptcopilot.percix.ai';
export const CDN_BASE_URL = 'https://cdn.ptcopilot.percix.ai/production';
export const RUM_APP_MONITOR_ID = '6562d1ef-44d0-4fd3-9b5d-b29f3802bd89';
export const RUM_MONITOR_BY_REGION: Record<string, string> = {"us-west-2":"91fabbba-e70a-4308-816f-79eeda6de246"};
export const SESSION_REPLAY_ENABLED = false;
// The published store extension id, hardcoded. The portal talks ONLY
// to this extension and ignores the id advertised on the DOM by the
// page bridge (which a co-installed hostile extension can also
// write). Chrome derives the id from the signing key, so it is a
// permanent public constant, identical in every environment -- a
// build-time variable would add a step that can be forgotten,
// silently shipping an unpinned production portal.
// Keep in sync with clinician-portal/src/externalConfig.ts.
export const PERCIX_EXTENSION_ID = 'jlnkfeodaagibopgjcaacdnifelmbnmk';
